import script from "./Term.vue?vue&type=script&setup=true&name=join_Term&lang=js"
export * from "./Term.vue?vue&type=script&setup=true&name=join_Term&lang=js"

const __exports__ = script;

export default __exports__